"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FeatureToggle = require("./FeatureToggle");
Object.keys(_FeatureToggle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FeatureToggle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FeatureToggle[key];
    }
  });
});
var _FeatureTogglesProvider = require("./FeatureTogglesProvider");
Object.keys(_FeatureTogglesProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FeatureTogglesProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FeatureTogglesProvider[key];
    }
  });
});
var _Off = require("./Off");
Object.keys(_Off).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Off[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Off[key];
    }
  });
});
var _On = require("./On");
Object.keys(_On).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _On[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _On[key];
    }
  });
});
